module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAQAAAD8fJRsAAAAwklEQVQY02WNu43CQABEnyXEJUd6FODrgBME5EfmAhAUQI7ogQYgBnogw+j4eHcWRyBSPgFy4AbITAAWoHvZ04xmAAA1tVCqVAs1yck8jRSaWuZlnqkp1CjzAHAdzeaFvDYvaOY6ANhtVIVNoETJJoCoarf3/ev0A5SYuqkrgX1R13twjv3XIPZ1AsD0NXyd0kB9APafbuda+blta7cqPST6dhdbAdCPvcQ+T9Rwh/WXLetof3lHPf3ZpevyHzfR+Gk3EMlkVJnxEiMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/commpany_map.png
// module id = tbXZ
// module chunks = 2